module.exports = __webpack_public_path__ + "media/academic.95d41c78.mp4";